'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require('../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _colorHelper = require('../../../../common/colors/colorHelper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BreadcrumbIcon = function BreadcrumbIcon(_ref) {
    var element = _ref.element,
        isRoot = _ref.isRoot;

    if (!element) return null;

    var iconStyle = {};

    var colorName = element.getIn(['content', 'color']);
    var hexValue = (0, _colorHelper.getColorHexValue)(colorName);

    if (hexValue) {
        iconStyle.backgroundColor = (0, _colorHelper.getColorHexValue)(colorName);
    }

    if (isRoot) {
        iconStyle.backgroundColor = 'transparent';
    }

    return _react2.default.createElement(
        'div',
        { className: 'breadcrumb-icon', style: iconStyle },
        isRoot ? _react2.default.createElement(_Icon2.default, { name: 'milanote-logo-small' }) : null
    );
};

// Utils


BreadcrumbIcon.propTypes = {
    element: _propTypes2.default.object,
    isRoot: _propTypes2.default.bool
};

exports.default = BreadcrumbIcon;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/breadcrumbs/BreadcrumbIcon.js
// module id = 2163
// module chunks = 0